var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{class:_vm.columnClass,attrs:{"cols":_vm.cols,"xl":_vm.xl,"lg":_vm.lg,"sm":_vm.sm,"md":_vm.md}},[_c('v-container',{class:_vm.containerClass},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }